import React from 'react';
import { connect } from 'dva';

import { framework_tool, utils_tool, component_tool } from '../../../../tool'
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizSpin } = component_tool
let { Session } = utils_tool
import SiteFrom from './siteFrom'

class TrainSiteDetail extends WizContainer {

    componentName = 'TrainSiteDetail';

    constructor(props) {
        super(props);
        this.state = {
            trainCenter: []
        }
        const { history } = props;
        let initialValue = {};
        let pageType = 'add'

        // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
        if (history.location && history.location.pathname === '/site/trainSite/trainSiteDetailUpd') {
            if (history.location && history.location.record) {
                initialValue = history.location.record;
                Session.set('trainSiteDetailUpd', initialValue)
            } else {
                initialValue = Session.get('trainSiteDetailUpd') || {};
            }
            pageType = 'upd';
        }
        this.initialValue = initialValue;
        this.pageType = pageType;
    }

    _componentWillMount() {
        this._getTrainCenter()
    }

    _getTrainCenter() {
        this.doAction({
            path: "trainCenter/info",
            payload: {
                key: "trainCenterInfo",
                apiParams: {}
            }
        });
    }

    propsAndStateOnChange = {
        trainCenter: this._trainCenter.bind(this),
        trainSite: this._trainSite.bind(this)
    }


    _trainCenter(nextProps, nextState) {
        let trainCenter = nextProps['trainCenter'];
        if (trainCenter['code'] === 1) {
            nextState['trainCenter'] = trainCenter['data'] || []
        }
        return true;
    }


    _trainSite(nextProps, nextState) {
        let trainSite = nextProps['trainSite'];
        if (trainSite['code'] === 1) {
            wizNotice.success(trainSite['msg'])
            this.jumpPage('push', '/site/trainSite')
        } else {
            wizNotice.error(trainSite && trainSite['msg'] || '操作失败,请稍后尝试')
        }
        return false;
    }

    _submit = (apiParams) => {
        this.doAction({
            path: this.pageType === 'add' ? "trainSite/add" : "trainSite/update",
            payload: {
                key: "trainSite",
                apiParams
            }
        });
    }

    _render() {
        let { trainCenter } = this.state
        return (
            <React.Fragment>
                <WizCard>
                    <WizSpin tip={"加载中"} spinning={false}>
                        <SiteFrom dataList={trainCenter} submit={(v) => { this._submit(v) }} data={this.initialValue} />
                    </WizSpin>
                </WizCard>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { trainCenter, trainSite } = state;
    const _trainCenter = modelUtils.getModelEntity(trainCenter, 'trainCenterInfo');
    const _trainSite = modelUtils.getModelEntity(trainSite, 'trainSite');
    return {
        trainCenter: _trainCenter,
        trainSite: _trainSite
    }
};

export default connect(mapStateToProps)(TrainSiteDetail);
